import { createSlice } from '@reduxjs/toolkit';

import { updateReviewAnonymity } from './actions';

import type { UpdateAnonymityState } from './types';
import type { ApiErrorCodeType } from 'store/apiTypes';

const initialState: UpdateAnonymityState = {
  isUpdating: false,
  error: null,
};

const updateAnonymitySlice = createSlice({
  name: 'updateAnonymity',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateReviewAnonymity.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(updateReviewAnonymity.fulfilled, (state) => {
        state.isUpdating = false;
      })
      .addCase(updateReviewAnonymity.rejected, (state, action) => {
        state.isUpdating = false;
        state.error = action.payload as { message: string; code: ApiErrorCodeType };
      });
  },
});

export const updateAnonymityReducer = updateAnonymitySlice.reducer;
